import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export default (props) => {
    return _jsx(_Fragment, { children: _jsxs("div", { className: `d-flex align-items-center ${props.className}`, children: [_jsx("hr", { className: "flex-grow-1" }), _jsx("span", { className: "px-2", children: props.children }), _jsx("hr", { className: "flex-grow-1" })] }) });
};
